import {
    addCollection, approveCollection, deleteCollection,
    getAllCollections,
    getSingleCollection,
    updateCollection
} from "@/services/modules/collection/collectionService";
import store from "@/state/store";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";

export const state = {
    physicalCollectionList: [],
    physicalCollectionListHeaders: [],
    physicalCollectionListLoading: false,
    noDataMessage: null,
};

export const mutations = {
    setNoDataMessage(state, data) {
        state.noDataMessage = data;
    },
    setPhysicalCollectionList(state, data) {
        state.physicalCollectionList = data
    },
    setPhysicalCollectionListHeaders(state, data) {
        state.physicalCollectionListHeaders = data
    },
    setPhysicalCollectionListLoading(state, data) {
        state.physicalCollectionListLoading = data
    }
}

export const actions = {
    async fetchAllCollections(context, {params, body}) {
        context.commit("setPhysicalCollectionListLoading", true);
        let headers = [
            {
                key: "date",
                label: "Tarih",
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: "currentCode",
                label: "Cari Kodu",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "currentName",
                label: "Cari Adı",
                sortable: false,
                class: "text-left align-middle"
            },
            {
                key: "salesPersonName",
                label: "Plasiyer",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "type",
                label: "Ödeme Tipi",
                sortable: false,
                class: "text-center align-middle"

            },
            {
                key: "description",
                label: "Açıklama",
                sortable: false,
                class: "text-left align-middle"
            },
            {
                key: "amount",
                label: "Tutar",
                sortable: false,
                class: "text-center align-middle"
            },
            {
                key: "isErp",
                label: "Durum",
                sortable: false,
                class: "text-center align-middle"
            },
        ];
        if (store.state.auth.user.RoleGroupId === 1 || store.state.auth.user.RoleGroupId === "1") {
            headers.push(
                {
                    key: "process",
                    label: "İşlem",
                    sortable: false,
                    class: "text-center align-middle"
                },
            );
        }
        context.commit("setPhysicalCollectionListHeaders", headers);
        let result = await getAllCollections(params, body);
        context.commit("setPhysicalCollectionListLoading", false);

        if (!result.data.success) {
            context.commit("setNoDataMessage", result.data.message);
            result = false;
            return result;

        } else {
            context.commit("setPhysicalCollectionList", result.data.data);
            return result;
        }
    },
    async fetchSingleCollection(context, {params, body, urlSegments}) {
        context;
        let result = await getSingleCollection(params, body, urlSegments);
        return result;
    },

    async collectionAdd(context, {params, body}) {
        context;
        let result = await addCollection(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            })
        } else {
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        }
        return result;
    },

    async collectionUpdate(context, {params, body}) {
        context;
        let result = await updateCollection(params, body);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },

    async collectionDelete(context, {params, body, urlSegments}) {
        context;
        showProcessPromptMessage({
            title: "Tahsilat Silinecek",
            text:
                "Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz ?",
        }).then(async function (confirm) {
            if (confirm.isConfirmed) {
                let result = await deleteCollection(params, body, urlSegments);
                if (result.data.success) {
                    showProcessSuccessMessage({
                        title: "İşlem Başarılı",
                        text: result.data.message,
                    })
                } else
                    showProcessErrorMessage({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    });

                return result;
            }
        });
    },
    async collectionApprove(context, {params, body, urlSegments}) {
        context;
        let result = await approveCollection(params, body, urlSegments);

        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.message,
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
}